/**
 * Marks a garden we seeded ourselves.
 *
 * The gallery would otherwise present a dozen worked examples as if the
 * community had posted them. It shows up next to the author on every card in
 * the feed and on the garden's own page — wherever a demo garden is visible,
 * this is visible with it.
 */
export function DemoBadge({ className = "" }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center shrink-0 px-2 py-0.5 rounded-lg bg-surface-container-high text-on-surface-variant text-label-md font-medium ${className}`}
      title="Potager de démonstration créé par Esprit Potager"
    >
      démonstration
    </span>
  );
}
